<main class="content-container row claim-detail" role="main" aria-labelledby="page-header">

  <header class="row">
    <!-- claim type with dynamic status indicator -->
    <dxo-status-indicator color="grey" [text]="claimTypeDisplay()" />
  </header>

  <section class="row double-even" aria-label="Employee and progress information">
    <!-- employee card -->
    <article class="employee-card">
      <dxo-card [bodyHeader]="employeeFullName()" role="region" aria-label="Employee information">

        <card-body>
          <div class="row double-even">
            <!-- birth date -->
            <dxo-label-value [label]="EmployeeLabel.BirthDate" [values]="[employeeBirthdate()]" />

            <!-- SSN -->
            <!-- <dxo-label-value [label]="EmployeeLabel.SSN" [values]="[employeeSsn()]" /> -->

            <!-- Gender -->
            <dxo-label-value [label]="EmployeeLabel.Gender" [values]="[employeeGender()]" />

            <!-- Work state -->
            @if (employeeWorkStateDisplay(); as workState) {
            <dxo-label-value [label]="EmployeeLabel.WorkState" [values]="[workState]" />
            }

            <!-- Division -->
            <dxo-label-value [label]="EmployeeLabel.Division" [values]="[divisionName()]" />
          </div>

        </card-body>

      </dxo-card>
    </article>

    <!-- progress card -->
    <article class="progress-card">
      <dxo-card role="region" aria-label="Claim progress information">

        <div class="content-container">
          <!-- progress tracker - use enhanced data if available, fallback to hardcoded -->
          @if (claimDataSignal()?.progressTracker?.steps) {
          <section aria-label="Progress tracker">
            <dxo-progress-tracker [items]="getProgressTrackerItems()" />
          </section>
          } @else {
          <section aria-label="Progress tracker">
            <dxo-progress-tracker [items]="[
                      {variant: 'complete', labelText: ProgressTrackerLabel.Received, messageText: formatDate(claimDataSignal()?.received)},
                      {variant: 'active', labelText: ProgressTrackerLabel.Processing, messageText: ProgressTrackerLabel.InProgress},
                      {variant: 'future-item', labelText: ProgressTrackerLabel.Closed}]" />
          </section>
          }


          <!-- progress body -->
          <card-body>
            <div class="row double-even">
              <!-- claim type -->
              <dxo-label-value [label]="ProgressSectionLabel.ClaimType" [values]="[claimTypeDisplay()]" />

              <!-- Case manager -->
              <dxo-label-value [label]="ProgressSectionLabel.CaseManager" [values]="[caseManagerDisplay()]" />

              <!-- start (dynamic label based on claim type) -->
              <dxo-label-value [label]="getClaimStartLabel()" [values]="[claimStartDate()]" />

            </div>

          </card-body>

        </div>

      </dxo-card>
    </article>
  </section>

  <!-- key dates card -->
  <section class="row single" aria-label="Key dates information">

    <!-- key dates card -->
    <article>
      <dxo-card class="key-dates-card" role="region" aria-labelledby="key-dates-header">

        <card-body class="row">

          <!-- header -->
          <h2 id="key-dates-header" class="card-body-header">Key dates</h2>

          <!-- hired -->
          <dxo-label-value [label]="KeyDateLabel.Hired" [values]="[formatKeyDate(claimDataSignal()?.keyDates?.hired)]" />

          <!-- claim start (dynamic label) -->
          <dxo-label-value [label]="getKeyDatesClaimStartLabel()" [values]="[keyDateClaimStart()]" />

          <!-- claim submitted -->
          <dxo-label-value [label]="KeyDateLabel.ClaimSubmitted" [values]="[keyDateClaimSubmitted()]" />

        </card-body>

      </dxo-card>
    </article>

  </section>

  <!-- benefit details card -->
  <section class="row single" aria-label="Coverage details">

    <!-- benefits card with dynamic content -->
    <article>
      <dxo-card class="benefit-details-card" bodyHeader="Coverage details" role="region" aria-labelledby="coverage-header">

        @if (claimBenefits().length) {
        <div class="row auto-fit-cols">
          <!-- Loop through benefit cards using ListCardComponent -->
          @for (benefitInput of benefitListCardInputs(); track trackByBenefitId($index, benefitInput.benefit!)) {
          <article>
            <app-list-card 
              [title]="benefitInput.title" 
              [statuses]="benefitInput.statuses"
              [attr.aria-label]="'Benefit: ' + benefitInput.title">
              
              <!-- Content projection for label-value pairs -->
              <div class="row auto-fit-cols">
                <!-- division & class -->
                <dxo-label-value [label]="BenefitLabel.DivisionAndClass"
                  [values]="[getBenefitDivisionClass(benefitInput.benefit!)]" />
                <!-- Reason -->
                <dxo-label-value [label]="BenefitLabel.Reason" [values]="[getBenefitReason(benefitInput.benefit!)]" />
                <!-- Benefit amount -->
                <dxo-label-value [label]="BenefitLabel.BenefitAmount"
                  [values]="[formatCurrency(benefitInput.benefit!.benefitAmount)]" />
                <!-- WOP-specific fields -->
                @if (benefitInput.benefit!.eliminationPeriod) {
                <dxo-label-value [label]="BenefitLabel.EliminationPeriod" [values]="[benefitInput.benefit!.eliminationPeriod]" />
                }
                @if (benefitInput.benefit!.effectiveDate) {
                <dxo-label-value [label]="BenefitLabel.EffectiveDate" [values]="[formatDate(benefitInput.benefit!.effectiveDate)]" />
                }
                @if (benefitInput.benefit!.terminationDate) {
                <dxo-label-value [label]="BenefitLabel.TerminationDate"
                  [values]="[formatDate(benefitInput.benefit!.terminationDate)]" />
                }
                <!-- Conditional waiver countdown/time remaining -->
                @if (getWaiverDisplayInfo(benefitInput.benefit!); as waiverInfo) {
                <dxo-label-value [label]="waiverInfo.label" [values]="[waiverInfo.value]" [tooltipContent]="waiverInfo.tooltip" />
                }
              </div>
              
            </app-list-card>
          </article>
          }
        </div>
        } @else {
        <div class="row auto-fit-cols">
          <article>
            <app-list-card 
              [title]="fallbackBenefitListCardInput().title" 
              [statuses]="fallbackBenefitListCardInput().statuses"
              [attr.aria-label]="'Benefit: ' + fallbackBenefitListCardInput().title">
              
              <!-- Fallback content projection -->
              <div class="row auto-fit-cols">
                <dxo-label-value [label]="ClaimLabel.Division" [values]="[divisionName()]" />
                <dxo-label-value [label]="ClaimLabel.Status" [values]="[claimStatus()]" />
              </div>
              
            </app-list-card>
          </article>
        </div>
        }

        <!-- Fallback for claims without enhanced benefit data -->

      </dxo-card>
    </article>

  </section>

  <!-- payments table (only if payment data exists) -->
  @if (claimDataSignal()?.payments?.length) {
  <section class="row single payments-table" aria-label="Payment information">
    <!-- payments card -->
    <article>
      <dxo-card class="payments-card" bodyHeader="Payments" role="region" aria-labelledby="payments-header">
        <card-body class="payments-table-body">
          <dxo-data-table [showCardViewWhenMobile]="true" [tableHeaderWrap]="false" [headers]="paymentTableHeaders"
            [items]="paymentTableItems()" [showDividers]="true" [showHover]="false" aria-label="Payment details table">
              <ng-template #sortIcon let-field>
                <dxo-icon [class.ascending]="paymentSortIconAscending()[field]"
                  [color]="paymentSortField === field | getSortIconColor" [fontSize]="20" [right]="true" aria-hidden="true">
                  sort
                </dxo-icon>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.CheckNumber">
                <span tabindex="0" class="sort-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.CheckNumber]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.CheckNumber]"
                  (click)="onClickPaymentTableHeader(PaymentField.CheckNumber)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.CheckNumber)">
                  {{ paymentHeaderTexts()[PaymentField.CheckNumber] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.CheckNumber }" />
                </span>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.CoverageType">
                <span tabindex="0" class="sort-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.CoverageType]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.CoverageType]"
                  (click)="onClickPaymentTableHeader(PaymentField.CoverageType)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.CoverageType)">
                  {{ paymentHeaderTexts()[PaymentField.CoverageType] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.CoverageType }" />
                </span>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.Payee">
                <span tabindex="0" class="sort-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.Payee]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.Payee]"
                  (click)="onClickPaymentTableHeader(PaymentField.Payee)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.Payee)">
                  {{ paymentHeaderTexts()[PaymentField.Payee] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.Payee }" />
                </span>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.PrintDate">
                <span tabindex="0" class="sort-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.PrintDate]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.PrintDate]"
                  (click)="onClickPaymentTableHeader(PaymentField.PrintDate)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.PrintDate)">
                  {{ paymentHeaderTexts()[PaymentField.PrintDate] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.PrintDate }" />
                </span>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.AmountPaid">
                <span tabindex="0" class="sort-header dollar-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.AmountPaid]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.AmountPaid]"
                  (click)="onClickPaymentTableHeader(PaymentField.AmountPaid)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.AmountPaid)">
                  {{ paymentHeaderTexts()[PaymentField.AmountPaid] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.AmountPaid }" />
                </span>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.InterestPaid">
                <span tabindex="0" class="sort-header dollar-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.InterestPaid]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.InterestPaid]"
                  (click)="onClickPaymentTableHeader(PaymentField.InterestPaid)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.InterestPaid)">
                  {{ paymentHeaderTexts()[PaymentField.InterestPaid] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.InterestPaid }" />
                </span>
              </ng-template>
              <ng-template [dxoHeaderKey]="PaymentField.NetPaid">
                <span tabindex="0" class="sort-header dollar-header" role="button"
                  [attr.aria-label]="paymentHeaderAriaLabels()[PaymentField.NetPaid]"
                  [attr.aria-sort]="paymentHeaderAriaSortValues()[PaymentField.NetPaid]"
                  (click)="onClickPaymentTableHeader(PaymentField.NetPaid)"
                  (keydown)="onKeydownPaymentTableHeader($event, PaymentField.NetPaid)">
                  {{ paymentHeaderTexts()[PaymentField.NetPaid] }}
                  <ng-container *ngTemplateOutlet="sortIcon; context: { $implicit: PaymentField.NetPaid }" />
                </span>
              </ng-template>
              <!-- Cell templates -->
              <ng-template [dxoKey]="PaymentField.CheckNumber" let-item>
                {{ item.checkNumber }}
              </ng-template>
              <ng-template [dxoKey]="PaymentField.CoverageType" let-item>
                {{ item.coverageType }}
              </ng-template>
              <ng-template [dxoKey]="PaymentField.Payee" let-item>
                {{ item.payee }}
              </ng-template>
              <ng-template [dxoKey]="PaymentField.PrintDate" let-item>
                {{ item.printDate }}
              </ng-template>
              <ng-template [dxoKey]="PaymentField.AmountPaid" let-item>
                <div class="dollar-cell">{{ item.amountPaid | currency:'USD':'symbol':'1.2-2' }}</div>
              </ng-template>
              <ng-template [dxoKey]="PaymentField.InterestPaid" let-item>
                <div class="dollar-cell">{{ item.interestPaid | currency:'USD':'symbol':'1.2-2' }}</div>
              </ng-template>
              <ng-template [dxoKey]="PaymentField.NetPaid" let-item>
                <div class="dollar-cell">{{ item.netPaid | currency:'USD':'symbol':'1.2-2' }}</div>
              </ng-template>
            </dxo-data-table>
          <footer class="payment-total" role="region" aria-label="Payment summary">
            <span class="total-label">Payment total</span>
            <span class="total-amount"
              [attr.aria-label]="'Total payment amount: ' + (netPaidTotal() | currency:'USD':'symbol':'1.2-2')">{{
              netPaidTotal() | currency:'USD':'symbol':'1.2-2' }}</span>
          </footer>
        </card-body>
      </dxo-card>
    </article>
  </section>
  }
</main>